<script lang="ts">
    import {Component, Prop, toNative, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'

    @Component({mixins: [Breadcrumbs]})
    export class FlightBreadcrumbs extends Vue {
        @Prop({required: true}) searchRequest

        get items() {
            const getSearchPageLabel = () => {
                const labels = flightsRuntimeStore.routes.map(
                    route => `${route.departure.iataCode} - ${route.arrival.iataCode}`
                )
                if (labels.length > 2) {
                    return labels.join(', ')
                } else {
                    return labels[0]
                }
            }
            const addSearchPageLink = items => {
                items.push({
                    title: getSearchPageLabel(),
                    to: flightsRuntimeStore.flightsPageLink(this.searchRequest),
                    exact: true,
                })
            }
            const addSchedulePageLink = items => {
                items.push({
                    title: getSearchPageLabel(),
                    to: flightsRuntimeStore.flightsSchedulePageLink(this.searchRequest),
                    exact: true,
                })
            }
            const name = useRoute().name
            const items = [this.homeItem]
            switch (name) {
                case 'flights':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'flightsSchedule':
                    items.push({
                        title: getSearchPageLabel(),
                        disabled: true,
                    })
                    break
                case 'flightsAvailability':
                    addSchedulePageLink(items)
                    items.push({
                        title: this.$t('availability'),
                        disabled: true,
                    })
                    break
                case 'flightBooking':
                    addSearchPageLink(items)
                    items.push({
                        title: this.$t('reservation'),
                        disabled: true,
                    })
                    break
                case 'flightConfirmation':
                    addSearchPageLink(items)
                    items.push({
                        title: this.$t('confirmation'),
                        disabled: true,
                    })
                    break
            }
            return items
        }
    }

    export default {...toNative(FlightBreadcrumbs), ssrRender: Breadcrumbs.ssrRender}
</script>
